import { AxiosResponseHeaders } from 'axios';
import { ExchangeRatesResponseDTO } from '../entities';

const exchangeRatesDTOToExchangeRatesAdapter = (data: ExchangeRatesResponseDTO, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { exchangeRatesDTOToExchangeRatesAdapter };
